import { render, staticRenderFns } from "./stored-photo.vue?vue&type=template&id=23abbfad&scoped=true"
import script from "./stored-photo.vue?vue&type=script&lang=js"
export * from "./stored-photo.vue?vue&type=script&lang=js"
import style0 from "./stored-photo.vue?vue&type=style&index=0&id=23abbfad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23abbfad",
  null
  
)

export default component.exports